import * as React from 'react';
import styles from './index.module.scss';
import cx from 'classnames';
import { Check, Stack } from '@fluentui/react';
import { getIcon } from '../../utils';
import { AcceptIcon, Flex, Image, Text } from '@fluentui/react-northstar';


const FileItem = ({
    id,
    thumbnail,
    title,
    metaData,
    checked: externalChecked,
    onItemClick,
    onCheckedChange,
    onCheckedItemChange,
    defaultColour,
    disable,
    big = false,
    showChecked = false,
    category = '',
    isMobile,
    disableClick,
    shareStatus = ''
}: {
    id: number;
    title: string;
    thumbnail: string;
    metaData: string;
    checked: boolean;
    disable: boolean;
    defaultColour?: string;
    onItemClick: () => void;
    onCheckedChange?: (flag: boolean) => void;
    onCheckedItemChange?: (fileId: number, flag: boolean) => void;
    big?: boolean;
    showChecked?: boolean;
    category?: string;
    isMobile?: boolean;
    disableClick?: boolean;
    shareStatus?: string;
}) => {

    const [isHover, setHover] = React.useState(false);
    const [checked, setChecked] = React.useState(externalChecked);
    const [mouseDown, setMousedown] = React.useState(false);
    const rootClass = cx(styles.container, checked && styles.checked, big && styles['big-container'], isHover && styles.hover, mouseDown && styles.focus);
    const inLineStyle: any = {};
    if (thumbnail && thumbnail.indexOf("data:image/svg") >= 0) {
        inLineStyle.backgroundColor = defaultColour;
        inLineStyle.backgroundPosition = 'inherit'
    }
    React.useEffect(() => {
        setChecked(externalChecked);
    }, [externalChecked]);
    const othersAttr: any = {
        onMouseDown: () => setMousedown(true),
        onMouseUp: () => setMousedown(false),
    };
    if (true) {
        othersAttr.onMouseEnter = () => setHover(true);
        othersAttr.onMouseLeave = () => setHover(false);
    }

    const renderDesktop = () => {
        return (
            <div className={rootClass} {...othersAttr} onClick={() => { disableClick && !disable && setChecked(!checked); (!disable && onCheckedItemChange) && onCheckedItemChange(id, !checked) }}>
                {showChecked && (isHover || checked) && <div onClick={() => { !disableClick && !disable && setChecked(!checked); (!disable && onCheckedItemChange) && onCheckedItemChange(id, !checked) }} className={styles.check}>
                    <Check checked={checked} /></div>
                }
                <div onClick={() => { !disableClick && onItemClick() }} className={styles.thumb}>
                   
                    <div className={styles.icon}>{getIcon(category)}</div>
                    {shareStatus && <span className={shareStatus == "blocked" ? styles.reddot : styles.greendot}></span>}
                    {thumbnail && <div className={styles.img} style={{ backgroundImage: `url(${thumbnail})`, ...inLineStyle }} />}
                </div>
                <figcaption onClick={() => { !disableClick && onItemClick() }} className={styles.title}>{title}</figcaption>
                <p onClick={() => { !disableClick && onItemClick() }} className={styles.sub}>{metaData}</p>
            </div>
        )
    };

    const renderMobile = () => {
        return (
            <Stack className={styles.rootMobile}>
                <Flex className={styles.innerContainer} gap="gap.medium" padding="padding.medium" onClick={() => { !disable && setChecked(!checked); (!disable && onCheckedItemChange) && onCheckedItemChange(id, !checked) }}>
                    {showChecked && (isHover || checked) && <div className={styles.check}>
                        <AcceptIcon style={{ backgroundColor: disable ? 'grey' : "#6264A7", color: "white" }} circular={true} size={"small"} />
                    </div>}
                    <div className={styles.thumbContainer}></div>
                    <Flex.Item className={styles.thumbContainer}>
                        <Flex className={styles.thumbInnerContainer}>
                            {shareStatus && <span className={shareStatus == "blocked" ? styles.reddot : styles.greendot}></span>}
                            <Image style={inLineStyle} className={styles.thumb} fluid src={thumbnail} />
                        </Flex>
                    </Flex.Item>
                    <Flex className={styles.sidepanelDivContainer}>
                        <Flex className={styles.sidepanelSpanContainer} column>
                            <Text className={styles.sidepanelSpanTitle}>{title}</Text>
                            <Text className={styles.sidepanelSpanDesc}>{metaData}</Text>
                        </Flex>
                    </Flex>
                </Flex>
                <Flex className={styles.seperator}></Flex>
            </Stack>
        )
    }

    return (
        <>
            {!isMobile && renderDesktop()}
            {isMobile && renderMobile()}
        </>
    );
};

export default FileItem